export const ObjectsRoutes = {
  SEARCH_PAGE: '/objects/search',
};
